export default __webpack_public_path__ + "static/media/beylikduzuImg2.76a2b31c.jpg";